<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">跨境电商解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          近年以来，随着中国对跨境电子商务业务政策的逐步放开、物流供应链及支付体系等的不断完善、跨境电商消费者队伍的不断状大及中国传统制造业的不断加入，中国跨境电子商务蓬勃发展，所占进出口总额比重逐年上升，已成为推动外贸增长的重要力量。<br>
          为响应国家号召，顺应市场需求，橡诺科技参照国内、国际先进案例，结合国内实际情况，科学地设计出“七体系两平台”总体建设框架（信息共享体系、智能物流体系、金融服务体系、电商信用体系、综合服务体系、风险防控体系和统计监测体系，以及线上“单一窗口”平台和线下“综合园区”平台），以“单一窗口”平台为建设核心，全力推进各城市战略实施。
          <div class="img"><img src="@/assets/img/solution/9/1.png"></div>
          “单一窗口”平台建设以信息化建设为基础，核心在于连接海关、国检、国税、外管、商务、工商、邮政、公安等政府管理部门，国际“单一窗口”，国家、地方电子口岸平台，以及电商、物流、金融机构等商业主体，为跨境电子商务企业及各监管部门、单位提供信息基础及交换平台。实现对跨境电子商务全方位、全过程监管和数据资源共享，满足外贸进出口企业跨境电子商务通关、物流、结汇、税收、数据交换、商务信息等各方面需求，并为消费者提供通关状态查询、质量风险预警及召回、税单查询等服务。建立和完善跨境电子商务发展的技术标准和管理规范，全面推进“一站式作业”，推动一体化通关管理，打造更加高效的口岸通关模式。
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          以大数据应用为核心，利用线上、线下平台，为海关、国检、外管、国税等管理部门，电商、物流、支付等跨境电子商务企业及个人消费者提供系统的跨境电子商务解决方案。
          <div class="img"><img src="@/assets/img/solution/9/2.png"></div>
          建立信息共享体系<br>
          统一信息标准规范、信息备案认证、信息管理服务，建立多位一体的跨境电子商务信息合作机制和共享平台，打通“关”“检”“税”“汇”“商”“物”“融”之间的信息壁垒，实现监管部门、地方政府、金融机构、电子商务企业、物流企业之间信息互联互通，为跨境电子商务信息流、资金流、货物流“三流合一”提供数据技术支撑。<br><br>
          建立金融服务体系<br>
          鼓励金融机构、第三方支付机构、第三方电子商务平台、外贸综合服务企业之间规范开展合作，利用跨境电子商务信息可查寻、可追溯的特点，为具有真实交易背景的跨境电子商务交易提供在线支付结算、在线融资、在线保险等完备便捷、风险可控的“一站式”金融服务。<br><br>
          建立智能物流体系<br>
          运用云计算、物联网、大数据等技术，充分利用现有物流公共信息平台，构建互联互通的物流智能信息系统、衔接顺畅的物流仓储网络系统、优质高效的物流运营服务系统等，实现物流供应链全程可验可测可控，探索建立高品质、标准化、规范化的跨境电子商务物流运作流程，形成布局合理、层次分明、衔接顺畅、功能齐全的跨境物流分拨配送和运营服务体系。<br><br>
          建立电商信用体系<br>
          综合多方信用基础数据，建立跨境电子商务信用数据库和信用评价系统、信用监管系统、信用负面清单系统等“一库三系统”，记录和积累跨境电子商务企业、平台企业、物流企业及其他综合服务企业基础数据，重点建立监管部门的信用认证体系和信用服务企业的信用评价体系，实现对电商信用的“分类监管、部门共享、有序公开”。<br><br>
          建立综合服务体系<br>
          为跨境电商企业提供电商服务、金融服务、物流服务等。主要包括三大部分服务内容：一是电商服务，为中小微跨境电商企业提供多店铺管理、通过技术手段实现将订单整理成符合监管部门要求的数据，并通过与单一窗口的无缝对接将数据传输至监管部门等服务，解决中小微企业多店铺管理繁琐、无专业技术团队支撑、信息化水平低及开展跨境业务的技术门槛等问题；二是为中小微企业提供金融服务，包含一站式结付汇、退税、保险在线购买等服务，通过平台大数据分析，建立企业征信体系，作为企业融资参考，与第三方金融服务机构合作，为中小微企业提供融资渠道，解决企业融资难的问题；三是国际物流特色服务，通过整合各类型物流服务企业，实现在线交易，价格透明化，服务个性化等，全面解决企业物流服务需求。<br><br>
          建立统计监测体系<br>
          利用大数据、云计算技术，对各类平台商品交易、物流通关、金融支付等海量数据进行分析处理运用，建立跨境电子商务大数据中心，实现跨境电子商务数据的交换汇聚；发布“跨境电子商务指数”，建立健全跨境电子商务统计监测体系，完善跨境电子商务统计方法，为政府监管和企业经营提供决策咨询服务。<br><br>
          建立风险防控体系<br>
          建立风险信息采集机制、风险评估分析机制、风险预警处置机制、风险复查完善机制，以流程节点风险防控为重点，开展跨境电子商务全流程的专业风险分析，有效防控非真实贸易洗钱的经济风险，数据存储、支付交易、网络安全的技术风险，以及产品安全、贸易摩擦、主体信用的交易风险，为政府监管提供有效的技术支撑、决策辅助和服务保障。<br><br>
          建立线上“单一窗口”平台<br>
          “单一窗口”平台坚持“一点接入”原则，建立数据标准和认证体系，与海关、检验检疫、税务、外汇管理、商务、工商、邮政等政府部门进行数据交换和互联互通，实现政府管理部门之间“信息互换、监管互认、执法互助”，实现通关全程无纸化，提高通关效率，降低通关成本。同时，通过链接金融、物流、电商平台、外贸综合服务企业等，为跨境电子商务企业和个人提供物流、金融等供应链商务服务。<br><br>
          对接线下“电子商务产业园区”平台<br>
          对接“电子商务产业园区”，打造电商产业“云聚合”服务体系，采取“一平台多园区”的布局方式，建设单一窗口平台配套线下“电子商务产业园区”平台，通过集聚电商平台企业、外贸综合服务企业、电商专业人才、电商专业服务等，提供通关、物流、金融、人才等“一站式”综合服务，有效承接线上“单一窗口”平台功能，深度对接政府职能部门、国内外知名网商、配套服务商、外贸进出口企业和境内外消费者，形成完整便捷的门到门一站式服务职能。<br><br>
          建立线下运营中心<br>
          组建本地运营团队，联合集团资源优势，建立线下运营中心。通过提供安全、技术、运营及政策保障等一整套成熟、完善的运营保障体系，确保“单一窗口”线上平台及线下业务的可持续化运营。确保平台运行的安全稳定性、有序性，使城市跨境电子商务业务规模化，为政府、企业带来经济效益，并带动城市产业、人才的发展。
        </div>
        
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>